import httpContext from 'express-http-context';

const setHttpContextValue = (name, value) => {
  if (httpContext) {
    httpContext.set(name, value);
  }
};

export default setHttpContextValue;
